/* eslint-disable */
import React, {Component} from 'react';
import authService from "../api-authorization/AuthorizeService";
import Select, {components, DropdownIndicatorProps} from 'react-select';
import {FieldsTable} from "./FieldsTable";
import {Button, Col, Form, Modal} from "react-bootstrap";
import Row from 'react-bootstrap/Row';
import {PredecessorTable} from "./PredecessorTable";
import {CalculatingElementsTable} from "./CalculatingElementsTable";
import {FertilizersTable} from "./FertilizersTable";
import {FertilizersCalculationTables} from "./FertilizersCalculationTables";
import {LimingTable} from "./LimingTable";
import FieldInfoBar from "./FieldInfoBar";
import DataTable from "react-data-table-component";
import {CropDataTable} from "./CropDataTable";
import arrow_down from '../../assets/icons/dark_arrow_down.png';
import arrow_up from '../../assets/icons/dark_arrow_up.png';
import {Typography} from "@material-ui/core";
import {Collapse} from 'react-collapse';
import search from "../../assets/icons/search.png";

export class SelectField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fields_name: [],
            fields: [],
            selected_field: [],
            fieldId: "",
            cropId: "",
            yield_plan: 0,
            yield_year: new Date().getFullYear(),
            usePredecessor: true,
            fieldChange: false,
            fertilizerChange: false,
            predecessorChange: false,
            calculationsChange: false,
            soils: [],
            soil_list: [],
            crops: [],
            crop_list: [],
            fertilizers: [],
            fertilizer_organic_list: [],
            mineralCoef: [],
            calculation_data: [],
            parent_report: [],
            calculateMessage: [],
            calculatedField: [],
            saveModalShow: false,
            fertilizerModalShow: false,
            report_name: '',
            report_info: {date_create: "", date_change: "", need_to_recalc: false},
            saveMessage: '',
            dose: [],
            fertilizer_calculation_data: {liming: [], feed: [], main: [], pre_sowing: [], balance: []},
            isLimingOpen: false,
            updateFertilizerlist: false,
            isLimingChange: false,
            mineralFertilizer: [],
            fertilizerCalculationChange: false,
            fertilizerCalculationsOpen: false,
            recalcIsVisible: true,
            fertilizer_limit: [0, 0, 0, 0, 0, 0],
            liming_sum_price: 0,
            liming_sum_dose: 0,
            fertilizer_sum_price: 0,
            soilGroup: [],
            limit_yield: {value: 0, element: ""},
            is_element_active: {n: true, p2O5: true, k2O: true, s: true, caO: true, mg: true},
            A: [],
            c: [],
            yield_price: 0,
            coefP: 3,
            other_price: {seeds: 0, szr: 0, yield: 0, input: 0},
            notes: '',
            changed_fertilizers_rows: [],
            expand: {
                regions: false,
                fertilizers: false,
                predecessor: false,
                liming: false,
                calculations: true,
                other: false
            },
            not_calculate_fertilizers_list: new Set(),
            prev_year: '',
            organic_sum_price: 0,
            useInputPrice: {fertilizers_calc: false, liming: false, organic: false},
            default_report_name: '',
            isNext: false,
            report_loading: false
        }
        this.handleChangeField = this.handleChangeField.bind(this);
        this.handleChangeFertilizer = this.handleChangeFertilizer.bind(this);
        this.handleChangePredecessorTable = this.handleChangePredecessorTable.bind(this);
        this.calculate = this.calculate.bind(this)
        this.saveAsCalculation = this.saveAsCalculation.bind(this)
        this.saveCalculation = this.saveCalculation.bind(this)
        this.SaveModal = this.SaveModal.bind(this)
        this.ChooseFertilizerModal = this.ChooseFertilizerModal.bind(this)
        this.calculate_main = this.calculate_main.bind(this)
        this.limingChange = this.limingChange.bind(this)
        this.fertilizerCalculationsInit = this.fertilizerCalculationsInit.bind(this)
        this.calculateLimit = this.calculateLimit.bind(this)
        this.handleChangeActiveElement = this.handleChangeActiveElement.bind(this)
        this.recalculate_A = this.recalculate_A.bind(this)
        this.calcNextYear = this.calcNextYear.bind(this)
        this.RecalcReport = this.RecalcReport.bind(this)
        this.syncStock = this.syncStock.bind(this)
        this.getResidue = this.getResidue.bind(this)
    }

    componentDidMount() {
        this.populateFieldsData();
    }

    async getResidue(field_id) {
        if (!this.isNext) {
            try {
                const response = await fetch('api/cropResidue/getFromCropwise', {
                    method: 'POST',
                    headers: !this.props.token
                        ? { 'Content-Type': 'application/json' }
                        : {
                            'Authorization': `Bearer ${this.props.token}`,
                            'Content-Type': 'application/json',
                        },
                    body: JSON.stringify({ field_id: field_id, year: this.state.yield_year }),
                });
                if (response.ok) {
                    const data = await response.json();
                    if (data.crop !== 0) {
                        this.state.selected_field[0].regions.map((r) => {
                            r.residue.cropId = data.crop
                        })
                        if (data.yield !== 0) {
                            this.state.selected_field[0].regions.map((r) => {
                                r.residue.yield = Math.round(data.yield*10)/10
                                this.state.predecessorChange = !this.state.predecessorChange
                            })
                        }
                        this.handleChangePredecessorTable()
                        
                    }
                } else {

                    console.error('Ошибка! HTTP статус:', response.status);
                }
            } catch (error) {
                console.error('Ошибка при выполнении запроса:', error);
            }
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.fieldId !== prevState.fieldId) {
            // eslint-disable-next-line array-callback-return
            this.state.fields.map((field) => {
                    if (field.id === this.state.fieldId) {
                        this.setState({selected_field: [field]})
                    }
                }
            );
        }
        if (this.state.selected_field !== prevState.selected_field && !this.props.report_id) {
            this.setState({
                calculationChange: !this.state.calculationChange,
                predecessorChange: !this.state.predecessorChange,
                fertilizerChange: !this.state.fertilizerChange,
                fieldChange: !this.state.fieldChange,
                isLimingChange: !this.state.isLimingChange,
                isLimingOpen: false,
                fertilizerCalculationsOpen: false
            });
            let data = [];
            // eslint-disable-next-line array-callback-return
            this.state.selected_field[0].regions.map((region) => {
                data.push({
                    name: region.name,
                    regionId: region.id,
                    element: {n: 0, p2O5: 0, k2O: 0, s: 0, caO: 0, mg: 0}
                })
            });
            this.setState({
                calculation_data: data,
                calculated_field: [{expand: true, element: {n: 0, p2O5: 0, k2O: 0, s: 0, caO: 0, mg: 0}}]
            }, () => {
                const field_element = this.state.calculated_field[0].element;
                const area = this.state.selected_field[0].area;
                this.setState({
                    dose: [{
                        expand: true,
                        element: {
                            n: Math.round(field_element.n / area * 10) / 10,
                            p2O5: Math.round(field_element.p2O5 / area * 10) / 10,
                            k2O: Math.round(field_element.k2O / area * 10) / 10,
                            s: Math.round(field_element.s / area * 10) / 10,
                            caO: Math.round(field_element.caO / area * 10) / 10,
                            mg: Math.round(field_element.mg / area * 10) / 10,
                        }
                    }]
                })
                this.calculateLimit()
            })
            this.limingChange(true)
        }
        if (this.state.calculation_data !== prevState.calculation_data) {
            this.setState({calculationChange: !this.state.calculationChange})
        }
        if (this.props.report_id !== prevProps.report_id) {
            window.location.reload();
        }
        if (this.state.dose !== prevState.dose) {
            // eslint-disable-next-line react/no-direct-mutation-state
            this.state.fertilizer_calculation_data.balance = this.state.dose
            this.setState({fertilizerCalculationChange: !this.state.fertilizerCalculationChange})
        }
        if (this.state.fertilizerCalculationsOpen !== prevState.fertilizerCalculationsOpen && !this.props.report_id) {
            this.fertilizerCalculationsInit()
        }
        if (this.state.fertilizer_limit !== prevState.fertilizer_limit) {
            this.calculateLimit()
        }
    }

    handleChangeActiveElement(el) {
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.is_element_active[el] = !this.state.is_element_active[el]
        this.setState({
            calculationChange: !this.state.calculationChange,
            fertilizerCalculationChange: !this.state.fertilizerCalculationChange
        })
    }

    limingChange(changeField = false) {
        if (this.state.fertilizer_calculation_data.liming.length === 0 || changeField || this.state.fertilizer_calculation_data.liming.length !== this.state.selected_field[0].regions.length) {
            let liming = []
            this.state.selected_field[0].regions.map((region) => liming.push({
                id: region.id,
                name: region.name,
                soilId: region.soilId,
                soil: this.state.soils.find((f) => f.id === region.soilId).name,
                humus: region.humus,
                pH: region.pH,
                dose: 0,
                area: region.area,
                fertilizer_dose: 0,
                fertilizer_id: null,
                intro_price: 0
            }))
            this.state.fertilizer_calculation_data.liming = liming
        } else {
            this.state.selected_field[0].regions.map((region, i) => {
                this.state.fertilizer_calculation_data.liming[i].id = region.id
                this.state.fertilizer_calculation_data.liming[i].name = region.name
                this.state.fertilizer_calculation_data.liming[i].soilId = region.soilId
                this.state.fertilizer_calculation_data.liming[i].soil = this.state.soils.find((f) => f.id === region.soilId).name
                this.state.fertilizer_calculation_data.liming[i].humus = region.humus
                this.state.fertilizer_calculation_data.liming[i].pH = region.pH
                this.state.fertilizer_calculation_data.liming[i].area = region.area

            })
        }
        this.setState({isLimingChange: !this.state.isLimingChange})
        // this.state.fertilizer_calculation_data.liming.length===0?
        //     this.state.fertilizer_calculation_data.liming =
        //
    }

    fertilizerCalculationsInit() {
        this.state.fertilizer_calculation_data.balance = [{
            price: 0,
            input_price: 0,
            element: this.state.dose[0] ? this.state.dose[0].element
                : {n: 0, p2O5: 0, k2O: 0, s: 0, mg: 0, caO: 0}
        }]
        this.state.fertilizer_calculation_data.main = [{
            id: 0,
            price: 0,
            input_price: 0,
            fertilizerId: 0,
            fertilizer_count: 0,
            element: {n: 0, p2O5: 0, k2O: 0, s: 0, caO: 0, mg: 0},
        }]
        this.state.fertilizer_calculation_data.pre_sowing = [{
            input_price: 0,
            id: 0,
            price: 0,
            fertilizerId: 0,
            fertilizer_count: 0,
            element: {n: 0, p2O5: 0, k2O: 0, s: 0, caO: 0, mg: 0},
        }]
        this.state.fertilizer_calculation_data.feed = [{
            id: 0,
            input_price: 0,
            price: 0,
            fertilizerId: 0,
            fertilizer_count: 0,
            element: {n: 0, p2O5: 0, k2O: 0, s: 0, caO: 0, mg: 0},
        }]
        this.setState({fertilizerCalculationChange: !this.state.fertilizerCalculationChange})
    }

    handleChangeField() {
        this.limingChange()
        this.setState({
            predecessorChange: !this.state.predecessorChange,
            isLimingChange: !this.state.isLimingChange,
            fertilizerChange: !this.state.fertilizerChange,
            calculationChange: !this.state.calculationChange,
        })
        this.calculate(false, this.state.yield_plan)
    }

    handleChangeFertilizer() {
        this.limingChange()
        this.setState({
            predecessorChange: !this.state.predecessorChange,
            isLimingChange: !this.state.isLimingChange,
            fieldChange: !this.state.fieldChange,
            calculationChange: !this.state.calculationChange,
        }, () => {
            this.calculate(false, this.state.yield_plan)
        });
    }

    handleChangePredecessorTable(change) {
        this.limingChange()
        this.setState({
            fieldChange: !this.state.fieldChange,
            fertilizerChange: !this.state.fertilizerChange,
            calculationChange: this.state.calculationChange,
            isLimingChange: !this.state.isLimingChange,
        }, () => this.calculate(false, this.state.yield_plan))
        if (change) {
            this.setState({predecessorChange: !this.state.predecessorChange})
        }
    }

    async saveAsCalculation() {
        this.setState({default_report_name: document.getElementById("region_name_input").value}, () => {
            this.setState({saveMessage: this.state.default_report_name === "" ? "Введите название отчета" : ""})
            const fertilizer_sum_price = ((this.state.isLimingOpen ? this.state.liming_sum_price : 0) + this.state.fertilizer_sum_price + this.state.organic_sum_price)
            const yield_sum_price = (this.state.yield_price * this.state.yield_plan * (this.state.selected_field.length !== 0 ? this.state.selected_field[0].area : 0) / 10)
            let main = this.state.fertilizer_calculation_data.main
            this.state.changed_fertilizers_rows.map((r) => {
                if (r.visible) {
                    main.push({
                        id: r.id.replaceAll('n', ''),
                        fertilizerId: r.fertilizerId,
                        fertilizer: r.fertilizer,
                        fertilizer_count: r.fertilizer_count,
                        price: r.price,
                        element: r.element,
                        input_price: r.input_price,
                    })
                }
            })
            let use_fertilizer_list = []
            this.state.mineralFertilizer.map((fertilizer) => {
                if (fertilizer.inUse)
                    use_fertilizer_list.push({id: 0, fertilizer_Id: fertilizer.id, calculationId: 0})
            })
            let calculation = {
                "id": 0,
                'prevCalcId': (this.state.prev_year !== null && this.state.prev_year.length !== 0) ? this.state.prev_year : null,
                "name": this.state.default_report_name,
                "field": this.state.selected_field[0],
                "fieldId": 0,
                "yield": this.state.yield_plan,
                "cropId": this.state.cropId,
                "sumElements": this.state.calculated_field[0].element,
                "sumElementArea": this.state.dose[0].element,
                "crop": this.state.crops.find((f) => {
                    return f.id === this.state.cropId;
                }),
                "usePredecessor": true,
                "calculations": [],
                'use_fertilizer_list': use_fertilizer_list,
                'yield_price': this.state.yield_price,
                'yield_year': this.state.yield_year,
                'fertilizer_sum_price': fertilizer_sum_price,
                'yield_sum_price': yield_sum_price,
                'isLimingOpen': this.state.isLimingOpen,
                'coefP': this.state.coefP,
                'liming_sum_price': this.state.liming_sum_price,
                'liming_sum_dose': this.state.liming_sum_dose,
                'is_element_active': this.state.is_element_active,
                'main_rows': main,
                'pre_sowing_rows': this.state.fertilizer_calculation_data.pre_sowing,
                'feed_rows': this.state.fertilizer_calculation_data.feed,
                'notes': this.state.notes,
                'other_price': this.state.other_price,

            }
            this.state.calculation_data.map((region, i) => {
                calculation.calculations.push({
                    "id": 0,
                    "calculationId": 0,
                    "elements": region.element,
                    "regionId": region.regionId,
                    'liming_dose': this.state.fertilizer_calculation_data.liming[i].dose,
                    'liming_fertilizer_dose': this.state.fertilizer_calculation_data.liming[i].fertilizer_dose,
                    'liming_fertilizerId': this.state.fertilizer_calculation_data.liming[i].fertilizer_id,
                    'liming_input_price': this.state.fertilizer_calculation_data.liming[i].intro_price
                })
            })
            fetch('api/calculation', {
                method: 'POST',
                headers: !this.props.token ? {} : {
                    'Authorization': `Bearer ${this.props.token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(calculation)
            }).then((response) => {
                if (response.ok) {
                    window.location.assign('/reports');
                } else {
                    this.setState({saveMessage: "Ошибка"})
                }
            })
        })

    }

    async saveCalculation() {
        let main = this.state.fertilizer_calculation_data.main
        this.state.changed_fertilizers_rows.map((r) => {
            if (r.visible) {
                main.push({
                    id: r.id.replaceAll('n', ''),
                    fertilizerId: r.fertilizerId,
                    fertilizer: r.fertilizer,
                    fertilizer_count: r.fertilizer_count,
                    price: r.price,
                    element: r.element,
                    input_price: r.input_price,
                })
            }
        })
        let use_fertilizer_list = []
        this.state.mineralFertilizer.map((fertilizer) => {
            if (fertilizer.inUse)
                use_fertilizer_list.push({id: 0, fertilizer_Id: fertilizer.id, calculationId: 0})
        })
        const fertilizer_sum_price = ((this.state.isLimingOpen ? this.state.liming_sum_price : 0) + this.state.fertilizer_sum_price + this.state.organic_sum_price)
        const yield_sum_price = (this.state.yield_price * this.state.yield_plan * (this.state.selected_field.length !== 0 ? this.state.selected_field[0].area : 0) / 10)
        let calculation = {
            "id": 0,
            "name": this.state.report_name,
            'prevCalcId': this.state.prev_year,
            "field": this.state.selected_field[0],
            "fieldId": 0,
            "yield": this.state.yield_plan,
            "cropId": this.state.cropId,
            "sumElements": this.state.calculated_field[0].element,
            "sumElementArea": this.state.dose[0].element,
            "crop": this.state.crops.find((f) => {
                return f.id === this.state.cropId;
            }),
            "usePredecessor": true,
            "calculations": [],
            'yield_price': this.state.yield_price,
            'use_fertilizer_list': use_fertilizer_list,
            'yield_year': this.state.yield_year,
            'fertilizer_sum_price': fertilizer_sum_price,
            'yield_sum_price': yield_sum_price,
            'isLimingOpen': this.state.isLimingOpen,
            'coefP': this.state.coefP,
            'liming_sum_price': this.state.liming_sum_price,
            'liming_sum_dose': this.state.liming_sum_dose,
            'is_element_active': this.state.is_element_active,
            'main_rows': main,
            'pre_sowing_rows': this.state.fertilizer_calculation_data.pre_sowing,
            'feed_rows': this.state.fertilizer_calculation_data.feed,
            'notes': this.state.notes,
            'other_price': this.state.other_price,
        }
        this.state.calculation_data.map((region, i) => {
            calculation.calculations.push({
                "id": 0,
                "calculationId": 0,
                "elements": region.element,
                "regionId": region.regionId,
                'liming_dose': this.state.fertilizer_calculation_data.liming[i].dose,
                'liming_fertilizer_dose': this.state.fertilizer_calculation_data.liming[i].fertilizer_dose,
                'liming_fertilizerId': this.state.fertilizer_calculation_data.liming[i].fertilizer_id,
                'liming_input_price': this.state.fertilizer_calculation_data.liming[i].intro_price
            })
        })
        fetch('api/calculation?id=' + this.props.report_id, {
            method: 'PUT',
            headers: !this.props.token ? {} : {
                'Authorization': `Bearer ${this.props.token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(calculation)
        }).then((response) => {
            if (response.ok) {
                window.location.assign('/reports');
            } else {
                this.setState({saveMessage: "Ошибка"})
            }
        })
    }

    calculate(limit, yield_plan) {
        try {
            if (!this.state.selected_field[0]) {
                this.setState({calculateMessage: 3})
                return false
            }
            if (!this.state.cropId) {
                this.setState({calculateMessage: 2})
                return false
            }
            let newData = []
            let vinos = this.multiplyScalar(this.getData(this.state.crops.find((f) => {
                return f.id === this.state.cropId;
            }).nutrient), yield_plan)
            let twoYearMineralCoef = this.getData(this.state.mineralCoef.find((f) => {
                return f.year === "2";
            }).coef)
            let cropCoefSoil = this.getData(this.state.crops.find((f) => {
                return f.id === this.state.cropId;
            }).coefSoil)
            let cropCoefFertilizer = this.getData(this.state.crops.find((f) => {
                return f.id === this.state.cropId;
            }).coefFertilizer)
            let cropBobCoef = this.state.crops.find((f) => {
                return f.id === this.state.cropId;
            }).coefBob
            this.state.selected_field[0].regions.map((region) => {
                let cropResidue = this.state.crops.find((f) => {
                    return f.id === region.residue.cropId;
                })
                let cropYieldResidue = cropResidue.cropGroup.cropResidues.sort(function (a, b) {
                    if (a.yield > b.yield) {
                        return -1;
                    }
                    if (a.yield < b.yield) {
                        return 1;
                    }
                    return 0;
                })
                let residueCoef = cropYieldResidue[0]
                let factYield = region.residue.yield
                cropYieldResidue.map((r) => {
                    if (factYield <= r.yield) {
                        residueCoef = r
                    }
                })
                let need
                let fromSoil
                if (this.state.usePredecessor) {
                    let twoYearMineral = this.multiplyVector(this.getData(region.residue.mineralElement), twoYearMineralCoef)
                    let temp = this.minusVector(vinos, twoYearMineral)
                    if (region.residue.fertilizerOrganic) {
                        let organicCount = this.multiplyScalar(this.getData(region.residue.fertilizerOrganic.consuming2), region.residue.fertilizerCount)
                        need = this.minusVector(temp, organicCount)
                    } else {
                        need = temp
                    }
                    let residue = this.multiplyScalar(this.getData(residueCoef.residueElement), factYield)
                    fromSoil = this.multiplyVector(this.plusVector(this.getData(region.element), residue), cropCoefSoil)
                } else {
                    need = vinos
                    fromSoil = this.multiplyVector(this.getData(region.element), cropCoefSoil)
                }
                let needFull
                needFull = this.minusVector(need, fromSoil)
                if (region.fertilizerOrganic) {
                    let OY = this.multiplyScalar(this.getData(region.fertilizerOrganic.consuming1), region.fertilizerCount)
                    needFull = this.minusVector(needFull, OY)
                }
                let ph = region.pH
                needFull[1] = needFull[1] * this.phCoefP2O5(ph)
                needFull[2] = needFull[2] * this.phCoefK2O(ph)
                let needFertilizer = this.multiplyVector(this.diffVector(needFull, cropCoefFertilizer), this.getData(region.soil.coef))
                needFertilizer[0] = needFertilizer[0] * cropBobCoef
                if (this.state.isLimingOpen && this.state.fertilizer_calculation_data.liming.length > 0) {
                    let fertilizerLiming = this.state.fertilizer_calculation_data.liming.find((r) => r.id == region.id)
                    let fertilizerMineral = this.state.mineralFertilizer.find(r => r.id == fertilizerLiming.fertilizer_id)
                    let fertilizerMineralOut = this.multiplyScalar(this.getData(fertilizerMineral.element), 1000 * fertilizerLiming.fertilizer_dose)
                    needFertilizer = this.minusVector(needFertilizer, fertilizerMineralOut)

                }
                newData.push(needFertilizer)
            })

            let regions_area = [];

            let data = [];
            this.state.selected_field[0].regions.map((region, i) => {
                regions_area.push(Number(region.area));
                data.push({
                    regionId: region.id,
                    name: region.name, element: {
                        n: Math.round(newData[i][0]),
                        p2O5: Math.round(newData[i][1]),
                        k2O: Math.round(newData[i][2]),
                        s: Math.round(newData[i][3]),
                        caO: Math.round(newData[i][4]),
                        mg: Math.round(newData[i][5]),
                    }
                })
            });
            let sum = [0, 0, 0, 0, 0, 0];
            if (true) {
                newData.map((row, j) => {
                    sum.map((el, i) => {
                        sum[i] += Math.round((row[i] > 0 ? row[i] : 0)) * regions_area[j];
                    })
                })
            } else {
                newData.map((row, j) => {
                    sum.map((el, i) => {
                        sum[i] += Math.round(row[i]) * regions_area[j];
                    })
                })
            }
            const field_row = [{
                expand: true,
                element: {n: sum[0], p2O5: sum[1], k2O: sum[2], s: sum[3], caO: sum[4], mg: sum[5]}
            }];
            const area = this.state.selected_field[0].area;
            const balance = [
                (Math.round(sum[0] / area * 10) / 10).toFixed(1),
                (Math.round(sum[1] / area * 10) / 10).toFixed(1),
                (Math.round(sum[2] / area * 10) / 10).toFixed(1),
                (Math.round(sum[3] / area * 10) / 10).toFixed(1),
                (Math.round(sum[4] / area * 10) / 10).toFixed(1),
                (Math.round(sum[5] / area * 10) / 10).toFixed(1)
            ]
            if (!limit) {
                this.setState({
                    calculation_data: data,
                    calculated_field: field_row,
                    calculateMessage: 0,
                    fertilizerCalculationsOpen: true
                }, () => {
                    const field_element = this.state.calculated_field[0].element;
                    this.setState({
                        dose: [{
                            expand: true,
                            element: {
                                n: (Math.round(field_element.n / area * 10) / 10).toFixed(1),
                                p2O5: (Math.round(field_element.p2O5 / area * 10) / 10).toFixed(1),
                                k2O: (Math.round(field_element.k2O / area * 10) / 10).toFixed(1),
                                s: (Math.round(field_element.s / area * 10) / 10).toFixed(1),
                                caO: (Math.round(field_element.caO / area * 10) / 10).toFixed(1),
                                mg: (Math.round(field_element.mg / area * 10) / 10).toFixed(1),
                            }
                        }]
                    })
                })
            }
            return balance

        } catch {
            this.setState({calculateMessage: 1})
            return false
        }
    }

    getData(data) {
        let newData = []
        Object.keys(data).map((currentKey) => {
            newData.push(data[currentKey])
        })
        return newData;
    }

    multiplyVector(A, B) {
        let newData = []
        for (let i = 0; i < A.length; i++) {
            newData.push(parseFloat(A[i]) * parseFloat(B[i]))
        }
        return newData
    }

    minusVector(A, B) {
        let newData = []
        for (let i = 0; i < A.length; i++) {
            newData.push(parseFloat(A[i]) - parseFloat(B[i]))
        }
        return newData
    }

    diffVector(A, B) {
        let newData = []
        for (let i = 0; i < A.length; i++) {
            newData.push(parseFloat(A[i]) / parseFloat(B[i]))
        }
        return newData
    }

    plusVector(A, B) {
        let newData = []
        for (let i = 0; i < A.length; i++) {
            newData.push(parseFloat(A[i]) + parseFloat(B[i]))
        }
        return newData
    }

    multiplyScalar(A, B) {
        let newData = []
        A.map((a) => {
            newData.push(parseFloat(a) * parseFloat(B))
        })
        return newData
    }

    phCoefP2O5(ph) {
        let coef
        if (ph < 5) {
            coef = 1.2
        } else if (ph >= 5 && ph <= 5.5) {
            coef = (-ph * 0.4) + 3.2
        } else if (ph > 5.5) {
            coef = 1
        }
        return coef
    }

    phCoefK2O(ph) {
        let coef
        if (ph < 5.6) {
            coef = 1.2
        } else if (ph >= 5.6 && ph <= 6.0) {
            coef = (-ph * 0.5) + 4
        } else if (ph > 6.0) {
            coef = 1
        }
        return coef
    }

    SaveModal(props) {
        return (
            <Modal show={props}
                   backdrop="static"
                   className='save-modal'
                   keyboard={false}
                   onHide={() => this.setState({saveModalShow: false})}
                   centered>
                <Modal.Header closeButton>
                    <Modal.Title>Введите название отчета</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Наименование</Form.Label>
                            <Form.Control
                                id='region_name_input'
                                onKeyDown=
                                    {(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault()
                                            this.saveAsCalculation()
                                        }
                                    }
                                    }
                                defaultValue={this.state.default_report_name}
                                autoFocus
                                autocomplete="off"
                            />
                        </Form.Group>
                    </Form>
                    <p style={{color: "red", fontSize: "14px"}}>{this.state.saveMessage}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button className='save-btn'
                            onClick={(e) => {
                                e.target.setAttribute("disabled", true);
                                this.saveAsCalculation(e)
                            }}>
                        Сохранить
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    recalculate_A(isFertilizersList) {
        let A = []
        if (this.state.mineralFertilizer.length > 0) {
            Object.keys(this.state.mineralFertilizer[0].element).map((currentKey) => {
                let temp = []
                this.state.mineralFertilizer.map(p => {
                    if (p.inUse && !this.state.not_calculate_fertilizers_list.has(p.id)) {
                        temp.push(p.element[currentKey])
                    } else
                        temp.push(0)
                })
                A.push(temp)
            })
        }
        this.setState({A: A}, () => isFertilizersList ? {} : this.calculate_main())
    }

    filterFertilizerList(value) {
        let rows = this.state.mineralFertilizer
        rows.forEach((row) => {
            row.hide = !row.name.toLowerCase().includes(value.toLowerCase())
        })
        this.setState({mineralFertilizer: rows})
    }


    syncStock(){
       let fertilizers = this.state.mineralFertilizer
        fertilizers.map((fertilizer)=>{
            fertilizer.inUse = fertilizer.inStorage
            }
        )
        this.setState({mineralFertilizer: fertilizers},()=>this.setState({updateFertilizerlist: !this.state.updateFertilizerlist}))
    }


    ChooseFertilizerModal(props) {
        const columns = [
            {
                cell: (row) =>
                    <label className="checkbox-fertilizer">
                        <input defaultChecked={row.inUse}
                               onChange={() => row.inUse = !row.inUse}
                               type="checkbox"/><span>j</span>
                    </label>,
                width: "5%"
            }, {
                name: 'Наименование',
                selector: row => row.name,
                sortable: true,
                width: "35%",
                wrap: true
            }, {
                name: 'N',
                selector: row => row.element.n,
                width: "10%"
            }, {
                name: 'P₂O₅',
                selector: row => row.element.p2O5,
                width: "10%"
            }, {
                name: 'K₂O',
                selector: row => row.element.k2O,
                width: "10%"
            }, {
                name: 'S',
                selector: row => row.element.s,
                width: "10%"
            }, {
                name: 'CaO',
                selector: row => row.element.caO,
                width: "10%"
            }, {
                name: 'Mg',
                selector: row => row.element.mg,
                width: "10%"
            }]
        return (
            <Modal show={props}
                   backdrop="static"
                   keyboard={false}
                   id='choose-fertilizer-modal'
                   size='lg'
                   onHide={() => this.setState({fertilizerModalShow: false})}
                   centered>
                <Modal.Header closeButton>
                    <Modal.Title id='choose-fertilizer-modal-label'>
                        Выберите удобрения для использования в расчетах
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="sync-stock-button-wrapper col">
                            <Button onClick={this.syncStock}>
                                Синхронизировать со складом
                            </Button>
                        </div>
                        <div className='search-container col'>
                            <input onInput={(e) => this.filterFertilizerList(e.target.value)}
                                   className='search-input'/>
                            <img className='search-img' src={search} alt='search'/>
                        </div>
                    </div>
                    <div id='choose-fertilizer-table'>
                        <DataTable
                            data={[]}
                            columns={columns}
                            persistTableHead={true}
                            noDataComponent={<></>}
                            customStyles={{
                                rows: {
                                    style: {
                                        height: '0',
                                    }
                                },
                                head: {
                                    style: {
                                        height: '73px!important',
                                        fontWeight: '500',
                                        fontSize: '20px',
                                        borderBottom: '0.5px solid #ABB3D1 !important'
                                    }
                                },
                                headRow: {
                                    style: {}
                                }
                            }}
                        />
                        <DataTable
                            data={this.state.mineralFertilizer.filter((fertilizer) => !fertilizer.hide)}
                            columns={columns}
                            noTableHead={true}
                            key={this.state.updateFertilizerlist}
                            noDataComponent='Удобрения не найдены'
                            customStyles={{
                                table: {
                                    style: {
                                        maxHeight: '450px',
                                        overflowY: 'scroll'
                                    }
                                },
                                rows: {
                                    style: {
                                        height: '65px!important',
                                        fontSize: '16px',
                                        border: '0 !important',
                                        borderTop: '0.5px solid #ABB3D1 !important'
                                    }
                                },
                            }}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button className='save-btn' onClick={() => this.setState({fertilizerModalShow: false}, () => {
                        this.recalculate_A(true)
                        this.setState({
                                isLimingChange: !this.state.isLimingChange,
                                fertilizerCalculationChange: !this.state.fertilizerCalculationChange
                            }
                        )
                    })}>
                        Сохранить
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    calculateLimit() {

        function getMaxOfArray(numArray) {
            let max = numArray[0]
            for (let i = 0; i < numArray.length; i++) {
                if (numArray[i] > max && element[i]) {
                    max = numArray[i]
                }
            }
            return max;
        }


        let element = [true, true, true, true, true, true]
        if (!this.state.is_element_active.n) {
            element[0] = false
        }
        if (!this.state.is_element_active.p2O5) {
            element[1] = false
        }
        if (!this.state.is_element_active.k2O) {
            element[2] = false
        }
        if (!this.state.is_element_active.s) {
            element[3] = false
        }
        if (!this.state.is_element_active.caO) {
            element[4] = false
        }
        if (!this.state.is_element_active.mg) {
            element[5] = false
        }
        let yield_plan = 0
        while (yield_plan <= 400 && this.state.cropId) {
            let balance = this.minusVector(this.calculate(true, yield_plan), this.state.fertilizer_limit)
            let ogr = []
            let isLimit = false
            let max = getMaxOfArray(balance)
            let isFirst = true
            for (let i = 0; i < balance.length; i++) {
                if (balance[i] >= 0.4 && element[i] && max == balance[i] && isFirst) {
                    isFirst = false
                    ogr.push(true)
                    isLimit = true
                } else {
                    ogr.push(false)
                }
            }
            if (isLimit) {
                let element = []
                for (let i = 0; i < ogr.length; i++) {
                    if (ogr[i]) {

                        if (i === 0) {
                            element.push("N")
                        }
                        if (i === 1) {
                            element.push("P₂O₅")
                        }
                        if (i === 2) {
                            element.push("K₂O")
                        }
                        if (i === 3) {
                            element.push("S")
                        }
                        if (i === 4) {
                            element.push("CaO")
                        }
                        if (i === 5) {
                            element.push("Mg")
                        }

                    }
                }
                yield_plan = Math.round((yield_plan - 1) * 10) / 10
                const limit = {value: yield_plan, element: element}
                this.setState({limit_yield: limit})
                break
            }


            yield_plan = Math.round((yield_plan + 1) * 10) / 10
        }

    }

    async calcNextYear() {
        const response_selected_field = await fetch('api/selectField?prevId=' + this.props.report_id, {
            headers: !this.props.token ? {} : {'Authorization': `Bearer ${this.props.token}`}
        });
        const selectedField = await response_selected_field.json()
        this.state.selected_field[0].regions.map((row) => {
            row.residue.cropId = this.state.cropId
            row.residue.yield = this.state.yield_plan
            row.residue.fertilizerCount = row.fertilizerCount
            row.residue.fertilizerOrganic = row.fertilizerOrganic
            row.residue.fertilizerOrganicId = row.fertilizerOrganicId
            row.residue.mineralElement.n = Math.round(this.state.fertilizer_limit[0])
            row.residue.mineralElement.p2O5 = Math.round(this.state.fertilizer_limit[1])
            row.residue.mineralElement.k2O = Math.round(this.state.fertilizer_limit[2])
            row.residue.mineralElement.s = Math.round(this.state.fertilizer_limit[3])
            row.residue.mineralElement.caO = Math.round(this.state.fertilizer_limit[4])
            row.residue.mineralElement.mg = Math.round(this.state.fertilizer_limit[5])
        })
        this.setState({
                cropId: "",
                yield_plan: 0,
                report_name: selectedField.defaultName,
                default_report_name: selectedField.defaultName,
                prev_year: this.props.report_id ? this.props.report_id : "",
                yield_year: Number(this.state.yield_year) + 1,
                usePredecessor: true,
                calculation_data: [],
                calculatedField: [],
                dose: [],
                fertilizer_calculation_data: {liming: [], feed: [], main: [], pre_sowing: [], balance: []},
                isLimingOpen: false,
                fertilizerCalculationsOpen: false,
                fertilizer_limit: [0, 0, 0, 0, 0, 0],
                limit_yield: {value: 0, element: ""},
                yield_price: 0,
                other_price: {seeds: 0, szr: 0, yield: 0, input: 0},
                fertilizer_sum_price: 0,
                organic_sum_price: 0,
                notes: '',
                isNext: true,
            }, () => {
                this.setState({predecessorChange: !this.state.predecessorChange, fieldChange: !this.state.fieldChange})
                this.limingChange()
            }
        )
    }

    async RecalcReport() {
        const parent_report = this.state.parent_report
        this.state.selected_field[0].regions.map((row, i) => {
            row.residue.cropId = parent_report.cropId
            row.residue.yield = parent_report.yield
            row.residue.fertilizerCount = parent_report.field.regions[i].fertilizerCount
            row.residue.fertilizerOrganic = parent_report.field.regions[i].fertilizerOrganic
            row.residue.fertilizerOrganicId = parent_report.field.regions[i].fertilizerOrganicId
            row.residue.mineralElement = parent_report.sumElementArea
            row.dateAnalyse = parent_report.field.regions[i].dateAnalyse
        })
        this.state.selected_field[0].name = parent_report.field.name
        this.state.selected_field[0].area = parent_report.field.area
        this.setState({
                fertilizer_calculation_data: {liming: [], feed: [], main: [], pre_sowing: [], balance: []},
                recalcIsVisible: false
            }, () => {
                this.limingChange()
                this.calculate(false, this.state.yield_plan)
            }
        )
    }

    render() {
        const priceFormat = new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2, maximumFractionDigits: 2})
        const numberFormat = new Intl.NumberFormat('ru-RU')
        const DropdownIndicator = (props: DropdownIndicatorProps<ColourOption, true>) => {
            return (
                <components.DropdownIndicator {...props}>
                    <img src={props.selectProps.menuIsOpen ? arrow_up : arrow_down} alt='arrow-down'
                         className='arrow'></img>
                </components.DropdownIndicator>
            );
        };

        function formatCell(value, price = false) {
            return value ? (price ? priceFormat : numberFormat).format(value.toString().replace(',', '.')).replace(',', '.') : 0
        }

        function NoOptionsMessage(props) {
            if (props.options.length) return null;
            return <Typography className='no-options-label' {...props.innerProps}>Нет полей</Typography>;
        }
        const field = this.state.selected_field.length !== 0 ? this.state.selected_field[0] : { name: '', area: '' }
        const crop = this.state.cropId !== "" ? this.state.crop_list.find((crop) => crop.value === this.state.cropId).label : ""
        let other_price = Number(this.state.other_price.seeds) + Number(this.state.other_price.szr) + Number(this.state.other_price.yield) + Number(this.state.other_price.input)
        let sum_other_price = (other_price + (this.state.fertilizer_sum_price + this.state.organic_sum_price) / (this.state.selected_field[0] ? this.state.selected_field[0].area : 1) + (this.state.isLimingOpen ? this.state.liming_sum_price : 0) / (this.state.selected_field[0] ? this.state.selected_field[0].area : 1)).toFixed(2)
        let yield_sum_price = (this.state.yield_price * this.state.yield_plan * (this.state.selected_field.length !== 0 ? this.state.selected_field[0].area : 0) / 10)
        let yield_sum_price_self = other_price * (this.state.selected_field[0] ? this.state.selected_field[0].area : 1) + this.state.fertilizer_sum_price + this.state.organic_sum_price + (this.state.isLimingOpen ? this.state.liming_sum_price : 0)
        let nav_content = [field.name + " " + field.area + (field.name !== '' ? " га, " : '') + crop,
            'Планируемая урожайность: ' + Number(this.state.yield_plan) + '  ц/га ',
            'Стоимость урожая: ' + priceFormat.format(yield_sum_price.toFixed(2)).replace(',', '.') + ' руб',
            'Себестоимость урожая: ' + priceFormat.format(yield_sum_price_self.toFixed(2)).replace(',', '.') + ' руб',
            'Расчетная урожайность: ' + ((this.state.limit_yield.value >= this.state.yield_plan) ?
                numberFormat.format(this.state.yield_plan.toString()).replace(',', '.') :
                numberFormat.format(this.state.limit_yield.value.toFixed(0)).replace(',', '.')) + '  ц/га',
            (((this.state.limit_yield.element.length !== 0) && (this.state.limit_yield.value.toFixed(0) !== '0') && (this.state.limit_yield.value < this.state.yield_plan)) ?
                ('Лимитирующий элемент: ' + this.state.limit_yield.element[0]) : '')]
        return (
            <>
                <FieldInfoBar key={this.state.fertilizerCalculationChange} content={nav_content}/>
                <Row className='page-label'>Расчет</Row>
                <Row>
                    {this.props.report_id ? (this.state.isNext ? <></> : (this.state.selected_field[0] ?
                            <Col>
                                <Row id='report-info'>
                                    <Col>
                                        <Row>Наименование: </Row>
                                        <Row>{this.state.report_name}</Row>
                                    </Col>
                                    <Col>
                                        <Row>Дата создания:</Row>
                                        <Row>{this.state.report_info.date_create !== "" ? new Date(this.state.report_info.date_create).toLocaleString() : ""}</Row>
                                    </Col>
                                    <Col>
                                        <Row>Дата изменения:</Row>
                                        <Row>{this.state.report_info.date_create !== "" ? new Date(this.state.report_info.date_change).toLocaleString() : ""}</Row>
                                    </Col>
                                </Row>
                                {this.state.report_info.need_to_recalc && this.state.recalcIsVisible ?
                                    <Row>
                                        <div className="recalc-label">
                                            Расчет на предыдущий год был изменен.
                                            Необходимо обновить этот расчет с учетом изменений!
                                        </div>
                                        <button onClick={this.RecalcReport} className='recalc-btn'>Обновить</button>
                                    </Row> : <></>}
                            </Col> : <></>)
                    ) : <></>}
                </Row>
                <Row>
                    {this.state.selected_field[0] ?
                        <CropDataTable
                            crop_list={this.state.crop_list}
                            key={this.state.fieldChange}
                            data={[{
                                cropId: this.state.cropId,
                                yield_price: this.state.yield_price,
                                yield_plan: this.state.yield_plan,
                                yield_year: this.state.yield_year
                            }]}
                            setCrop={(value) => this.setState({ cropId: value }, () => {
                                this.calculate(false, this.state.yield_plan)
                            })}
                            setYieldPlan={(value) => this.setState({ yield_plan: value }, () => this.calculate(false, this.state.yield_plan))}
                            setYieldPrice={(value) => this.setState({ yield_price: value })}
                            setYieldYear={(value) => {
                                this.setState({ yield_year: value });
                                this.getResidue(this.state.fieldId)
                            }}
                        >
                        </CropDataTable> : <></>}
                </Row>
                <Row>
                    {this.props.report_id ? <></>
                        : this.state.fieldId ? <></> :
                            <Col>
                                <Select
                                    className='field-select'
                                    maxMenuHeight='230px'
                                    menuIsOpen={true}
                                    options={this.state.fields_name}
                                    components={{DropdownIndicator, NoOptionsMessage}}
                                    theme={(theme) => ({
                                        ...theme,
                                        border: '1px solid #ABB3D1',
                                        borderRadius: '10px',
                                        colors: {
                                            ...theme.colors,
                                            primary: '#ABB3D1',
                                        },
                                    })}
                                    styles={{
                                        container: (baseStyles, state) => ({
                                            ...baseStyles,
                                            width: '428px',
                                            height: '52px',
                                        }),
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            background: state.isFocused ? '#fff' : '#E9EAEE',
                                            height: '52px',
                                            width: '428px',
                                        }),
                                        menu: (baseStyles, state) => ({
                                            ...baseStyles,
                                            border: ' 1px solid #ABB3D1',
                                            borderRadius: '10px',
                                            margin: '0'
                                        }),
                                        option: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: '#201E44',
                                            height: '45px',
                                            backgroundColor: state.isFocused ? 'rgba(226, 228, 239, 0.5)' : "white",
                                        }),
                                        menuList: (baseStyles, state) => ({
                                            ...baseStyles,
                                            paddingRight: '13px !important',
                                            "::-webkit-scrollbar": {
                                                width: '3px !important'
                                            },
                                            "::-webkit-scrollbar-track": {
                                                background: '#E2E4EF !important',
                                                borderRadius: '6px !important'
                                            },
                                            "::-webkit-scrollbar-thumb": {
                                                background: ' #ABB3D1 !important',
                                                borderRadius: '6px !important'
                                            },
                                            "::-webkit-scrollbar-thumb:hover": {
                                                background: ' #ABB3D1 !important',
                                            }
                                        })
                                    }}
                                    onChange={(event) => {
                                        this.getResidue(event.value)
                                        this.setState({
                                            fieldId: event.value,
                                            saveMessage: "",
                                            calculateMessage: ""
                                        })
                                    }}
                                    placeholder="Выберите поле"
                                />
                            </Col>
                    }
                </Row>
                <Row>
                    <FieldsTable key={this.state.fieldChange}
                        isReport={this.props.report_id}
                        classChange={this.state.classChange}
                        fields_name={this.state.fields_name}
                        field={this.state.selected_field}
                        onFieldChange={this.handleChangeField}
                        soil_list={this.state.soil_list}
                        soil={this.state.soils}
                        token={this.props.token}
                        expand={this.state.expand.regions}
                        changeExpand={() => {
                            this.state.expand.regions = !this.state.expand.regions
                            this.setState({ fieldChange: !this.state.fieldChange })
                        }}
                        changeField={(value) => {
                            this.getResidue(value);
                                this.setState({
                                    fieldId: value,
                                    saveMessage: "",
                                    calculateMessage: ""
                                })
                        }
                        }
                    ></FieldsTable>
                </Row>
                <Row>
                    <PredecessorTable key={this.state.predecessorChange}
                                      field={this.state.selected_field}
                                      crop_list={this.state.crop_list}
                                      fertilizers={this.state.fertilizers}
                                      fertilizer_organic_list={this.state.fertilizer_organic_list}
                                      onPredecessorChange={this.handleChangePredecessorTable}
                                      expand={this.state.expand.predecessor}
                                      changeExpand={() => {
                                          this.state.expand.predecessor = !this.state.expand.predecessor
                                          this.setState({predecessorChange: !this.state.predecessorChange})
                                      }}>
                    </PredecessorTable>
                </Row>
                <Row>
                    <LimingTable
                        liming={this.state.fertilizer_calculation_data.liming}
                        setLiming={(value) => this.state.fertilizer_calculation_data.liming = value}
                        key={this.state.isLimingChange}
                        fertilizer_mineral_list={this.state.mineralFertilizer?.filter((r) => r.inUse)}
                        fertilizers={this.state.fertilizers}
                        soils={this.state.soils}
                        soilGroup={this.state.soilGroup}
                        field={this.state.selected_field}
                        sum_price={this.state.liming_sum_price}
                        sum_dose={this.state.liming_sum_dose}
                        setSumPrice={(value) => this.setState({liming_sum_price: value}, () => {
                            this.calculate(false, this.state.yield_plan)
                        })}
                        setSumDose={(value) => this.setState({liming_sum_dose: value})}
                        isLimingOpen={this.state.isLimingOpen}
                        useLiming={() => this.setState({
                            isLimingOpen: !this.state.isLimingOpen,
                        }, () => {
                            this.calculate(false, this.state.yield_plan)
                        })}
                        expand={this.state.expand.liming}
                        changeExpand={() => {
                            this.state.expand.liming = !this.state.expand.liming
                            this.setState({isLimingChange: !this.state.isLimingChange})
                        }}
                        useInputPrice={this.state.useInputPrice.liming}
                        setUseInputPrice={() => {
                            this.setState({
                                    useInputPrice: {
                                        liming: !this.state.useInputPrice.liming,
                                        fertilizers_calc: this.state.useInputPrice.fertilizers_calc,
                                        organic: this.state.useInputPrice.organic
                                    }
                                },
                                () => this.setState({isLimingChange: !this.state.isLimingChange}))
                        }}
                    ></LimingTable>
                </Row>
                <Row>
                    <FertilizersTable
                        key={this.state.fertilizerChange}
                        field={this.state.selected_field}
                        fertilizer_organic_list={this.state.fertilizer_organic_list}
                        fertilizers={this.state.fertilizers}
                        setSumPrice={(value) => this.setState({organic_sum_price: value})}
                        onFertilizerChange={this.handleChangeFertilizer}
                        style={{maxWidth: '90%'}}
                        expand={this.state.expand.fertilizers}
                        changeExpand={() => {
                            this.state.expand.fertilizers = !this.state.expand.fertilizers
                            this.setState({fertilizerChange: !this.state.fertilizerChange})
                        }}
                        useInputPrice={this.state.useInputPrice.organic}
                        setUseInputPrice={() => {
                            this.setState({
                                    useInputPrice: {
                                        liming: this.state.useInputPrice.liming,
                                        fertilizers_calc: this.state.useInputPrice.fertilizers_calc,
                                        organic: !this.state.useInputPrice.organic
                                    }
                                },
                                () => this.setState({fertilizerChange: !this.state.fertilizerChange}))
                        }}
                    ></FertilizersTable>
                </Row>
                <Row>
                    <CalculatingElementsTable key={this.state.calculationChange}
                                              field_row={this.state.calculated_field}
                                              calculation_data={this.state.calculation_data}
                                              dose_row={this.state.dose}
                                              isActive={this.state.is_element_active}
                                              handleCheckElement={this.handleChangeActiveElement}
                                              expand={this.state.expand.calculations}
                                              changeExpand={() => {
                                                  this.state.expand.calculations = !this.state.expand.calculations
                                                  this.setState({calculationChange: !this.state.calculationChange})
                                              }}
                    ></CalculatingElementsTable>
                </Row>
                <Row>
                    {this.state.fertilizerModalShow ? this.ChooseFertilizerModal(this.state.fertilizerModalShow) : <></>}
                    <FertilizersCalculationTables fertilizer_data={this.state.fertilizer_calculation_data}
                                                  key={this.state.fertilizerCalculationChange}
                                                  visible={this.state.fertilizerCalculationsOpen}
                                                  fertilizer_mineral_list={this.state.mineralFertilizer?.filter((r) => r.inUse)}
                                                  fertilizers={this.state.fertilizers}
                                                  calculate_main={this.calculate_main}
                                                  balance={this.state.dose}
                                                  isActive={this.state.is_element_active}
                                                  setFertilizerLimit={(value) => this.setState({fertilizer_limit: value})}
                                                  area={this.state.selected_field[0] ? this.state.selected_field[0].area : 0}
                                                  coefP={this.state.coefP}
                                                  report_loading={this.state.report_loading}
                                                  changeCoefP={(value) => this.setState({report_loading: false},()=>this.setState({coefP: value}, () => this.setState(
                                                      {fertilizerCalculationChange: !this.state.fertilizerCalculationChange})))}
                                                  setSumPrice={(value) => this.setState({fertilizer_sum_price: value})}
                                                  showModal={() => this.setState({fertilizerModalShow: true})}
                                                  changed_rows={this.state.changed_fertilizers_rows}
                                                  not_calculate_fertilizers_list={this.state.not_calculate_fertilizers_list}
                                                  recalculate_A_c={this.recalculate_A}
                                                  useInputPrice={this.state.useInputPrice.fertilizers_calc}
                                                  setUseInputPrice={() => {
                                                      this.setState({
                                                              useInputPrice:
                                                                  {
                                                                      fertilizers_calc: !this.state.useInputPrice.fertilizers_calc,
                                                                      liming: !this.state.useInputPrice.liming,
                                                                      organic: !this.state.useInputPrice.organic
                                                                  }
                                                          },
                                                          () => this.setState({fertilizerCalculationChange: !this.state.fertilizerCalculationChange}))
                                                  }}
                    >
                    </FertilizersCalculationTables>
                </Row>
                <Row style={{display: this.state.selected_field.length !== 0 ? '' : 'none'}}>
                    <div className="label-btn-container others">
                        <Button className="label-button" onClick={() => {
                            this.state.expand.other = !this.state.expand.other
                            this.forceUpdate()
                        }}>
                            Прочие затраты
                            <img src={this.state.expand.other ? arrow_up : arrow_down} className='btn-arrow'
                                 alt='arrow'/>
                        </Button>
                    </div>
                    <Collapse isOpened={this.state.expand.other}>
                        <div className='row'>
                            <div className='col other-costs'>
                                <Form>
                                    <Form.Label className='price'>руб/га</Form.Label>
                                    <Form.Group as={Row}>
                                        <Col><Form.Label>Подготовительные и посевные
                                            работы</Form.Label></Col>
                                        <Col><Form.Control
                                            className={this.state.other_price.seeds == 0 ? 'other-costs-placeholder' : ''}
                                            value={this.state.other_price.seeds}
                                            onClick={(e) => e.target.select()}
                                            onChange={(e) => this.setState({
                                                other_price:
                                                    {
                                                        yield: this.state.other_price.yield,
                                                        seeds: e.target.value.replace(',', '.'),
                                                        szr: this.state.other_price.szr,
                                                        input: this.state.other_price.input
                                                    }
                                            })}
                                        >
                                        </Form.Control></Col>
                                    </Form.Group>
                                    <Form.Group as={Row}>
                                        <Col><Form.Label>Защита растений</Form.Label></Col>
                                        <Col><Form.Control
                                            value={this.state.other_price.szr}
                                            className={this.state.other_price.seeds == 0 ? 'other-costs-placeholder' : ''}
                                            onClick={(e) => e.target.select()}
                                            onChange={(e) => this.setState({
                                                other_price:
                                                    {
                                                        yield: this.state.other_price.yield,
                                                        seeds: this.state.other_price.seeds,
                                                        szr: e.target.value.replace(',', '.'),
                                                        input: this.state.other_price.input
                                                    }
                                            })}>
                                        </Form.Control></Col>
                                    </Form.Group>
                                    <Form.Group as={Row}>
                                        <Col><Form.Label>Уборка урожая</Form.Label></Col>
                                        <Col><Form.Control
                                            value={this.state.other_price.yield}
                                            className={this.state.other_price.seeds == 0 ? 'other-costs-placeholder' : ''}
                                            onClick={(e) => e.target.select()}
                                            onChange={(e) => this.setState({
                                                other_price:
                                                    {
                                                        yield: e.target.value.replace(',', '.'),
                                                        seeds: this.state.other_price.seeds,
                                                        szr: this.state.other_price.szr,
                                                        input: this.state.other_price.input
                                                    }
                                            })}>
                                        </Form.Control></Col>
                                    </Form.Group>
                                    <Form.Group as={Row}>
                                        <Col><Form.Label>Внесение удобрений</Form.Label></Col>
                                        <Col><Form.Control
                                            value={this.state.other_price.input}
                                            onClick={(e) => e.target.select()}
                                            className={this.state.other_price.seeds == 0 ? 'other-costs-placeholder' : ''}
                                            onChange={(e) => this.setState({
                                                other_price:
                                                    {
                                                        input: e.target.value.replace(',', '.'),
                                                        yield: this.state.other_price.yield,
                                                        seeds: this.state.other_price.seeds,
                                                        szr: this.state.other_price.szr
                                                    }
                                            })}>
                                        </Form.Control></Col>
                                    </Form.Group>
                                    <hr/>
                                    <Form.Group as={Row}>
                                        <Col><Form.Label className='sum-price'>Итого руб/га</Form.Label></Col>
                                        <Col><Form.Control
                                            plaintext readOnly
                                            value={formatCell(other_price, true)}>
                                        </Form.Control></Col>
                                    </Form.Group>
                                    <Form.Group as={Row}>
                                        <Col><Form.Label className='sum-price'>Итого руб/поле</Form.Label></Col>
                                        <Col><Form.Control
                                            plaintext readOnly
                                            value={formatCell(other_price * (this.state.selected_field[0] ? this.state.selected_field[0].area : 0), true)}>
                                        </Form.Control></Col>
                                    </Form.Group>
                                </Form>
                            </div>
                            <div className='col notes-container'>
                                <div className="shadow1"></div>
                                <div className="shadow2"></div>
                                <Form.Control className='notes' as='textarea' rows={5} value={this.state.notes}
                                              placeholder='Введите текст...'
                                              onChange={(e) => this.setState({notes: e.target.value})}></Form.Control>
                            </div>
                        </div>
                    </Collapse>
                </Row>
                <Row className='save-row' style={{
                    display: (this.state.calculation_data !== [] && this.state.selected_field.length !== 0) ? "" : "none"
                }}>
                    <Col style={{maxWidth: '250px'}}>
                        <Button className='save-as-btn'
                                onClick={() => this.setState({saveModalShow: true})}>Сохранить как</Button>
                        {this.SaveModal(this.state.saveModalShow)}
                    </Col>
                    <Col style={{
                        maxWidth: (this.state.report_name !== "") && (!this.state.saveModalShow) && (!this.state.isNext) ? '250px' : '0',
                        marginRight: (this.state.report_name !== "") && (!this.state.saveModalShow) && (!this.state.isNext) ? '80px' : '0'
                    }}>
                        <Button
                            className='save-as-btn'
                            style={{display: (this.state.report_name !== "") && (!this.state.saveModalShow) && (!this.state.isNext) ? "" : "none"}}
                            onClick={this.saveCalculation}>Сохранить</Button>
                    </Col>
                    <Col style={{maxWidth: '250px'}}>
                        <Button
                            className='redirect-reports-btn'
                            onClick={() => window.location.assign('/reports')}>Перейти к отчетам</Button>
                    </Col>
                    <Col>
                        <Button
                            style={{display: (this.state.selected_field.length !== 0 && !this.state.isNext) ? "" : "none",}}
                            className='calc-next-year-btn'
                            onClick={this.calcNextYear}> Рассчитать на следующий год</Button>
                    </Col>
                </Row>
            </>
        )
            ;
    }

    calculate_main() {
        function minus_col(A) {
            let temp = []
            for (let i = 0; i < A.length; i++) {
                temp.push(minus(A[i]))
            }
            return temp
        }

        function minus(C) {
            let temp = []
            for (let i = 0; i < C.length; i++) {
                temp.push(-C[i])
            }
            return temp
        }

        const balance = this.state.fertilizer_calculation_data.balance[0].element
        let B = [balance.n, balance.p2O5, balance.k2O, balance.s, balance.caO, balance.mg]
        let C = this.state.c
        let A = this.state.A
        if (!this.state.is_element_active.n) {
            B[0] = 0
        }
        if (!this.state.is_element_active.p2O5) {
            B[1] = 0
        }
        if (!this.state.is_element_active.k2O) {
            B[2] = 0
        }
        if (!this.state.is_element_active.s) {
            B[3] = 0
        }
        if (!this.state.is_element_active.caO) {
            B[4] = 0
        }
        if (!this.state.is_element_active.mg) {
            B[5] = 0
        }
        let tableJSON = {"a": minus_col(A), "b": minus(B), "c": minus(C)}
        fetch('api/Calculation/CalculateFertilizer', {
            method: 'POST',
            headers: !this.props.token ? {} : {
                'Authorization': `Bearer ${this.props.token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(tableJSON)
        }).then((response) => {
            if (response.ok) {
                response.json().then((result) => {
                    let newMain = []
                    for (let i = 0; i < result.length; i++) {

                        if (result[i] > 0.001) {
                            newMain.push({
                                id: i,
                                fertilizerId: this.state.mineralFertilizer[i].id,
                                fertilizer_count: result[i].toFixed(1),
                                price: 0,
                                input_price: 0,
                                element: {
                                    n: result[i].toFixed(1) * this.state.mineralFertilizer[i].element.n,
                                    p2O5: result[i].toFixed(1) * this.state.mineralFertilizer[i].element.p2O5,
                                    k2O: result[i].toFixed(1) * this.state.mineralFertilizer[i].element.k2O,
                                    s: result[i].toFixed(1) * this.state.mineralFertilizer[i].element.s,
                                    caO: result[i].toFixed(1) * this.state.mineralFertilizer[i].element.caO,
                                    mg: result[i].toFixed(1) * this.state.mineralFertilizer[i].element.mg
                                },
                            })
                        }
                    }
                    this.state.fertilizer_calculation_data.main = newMain.length !== 0 ? newMain : this.state.changed_fertilizers_rows.length !== 0 ? [] :
                        [{
                            id: 0,
                            price: 0,
                            fertilizerId: 0,
                            fertilizer_count: 0,
                            element: {n: 0, p2O5: 0, k2O: 0, s: 0, caO: 0, mg: 0},
                        }]
                    this.setState({fertilizerCalculationChange: !this.state.fertilizerCalculationChange})
                })
            }
        })
    }

    async populateFieldsData() {
        let response_report
        let report = []
        let parent_report = []
        if (this.props.report_id) {
            response_report = await fetch('api/calculation?id=' + this.props.report_id, {
                headers: !this.props.token ? {} : {'Authorization': `Bearer ${this.props.token}`}
            });
            const report_data = await response_report.json();
            report = report_data.currentCalculation
            parent_report = report_data.prevCalculation
        }
        const response_selectField = await fetch('api/selectField?prevId=' + (this.props.report_id ? (report.prevCalcId !== null ? report.prevCalcId : '') : this.state.prev_year), {
            headers: !this.props.token ? {} : {'Authorization': `Bearer ${this.props.token}`}
        });
        const response_fertilizer_organic = await fetch('api/fertilizerOrganic', {
            headers: !this.props.token ? {} : {'Authorization': `Bearer ${this.props.token}`}
        });
        let fields = []
        let fields_all = []
        let soil_list = []
        const selectField = await response_selectField.json()
        const soils = selectField.soils
        const soilGroup = selectField.soilsGroup
        const crops = selectField.crops
        const fertilizers = await response_fertilizer_organic.json()
        const report_name = selectField.defaultName
        const mineralCoef = selectField.mineralFertilizerCoef
        const mineralFertilizer = selectField.mineralFertilizerStorages
        const calculation_data = [];
        let fertilizer_calculation_data = {liming: [], balance: []}
        let organic_sum_price = 0
        if (this.props.report_id) {
            let fertilizer
            report.field.regions.map((region) => {
                fertilizer = fertilizers.find((f) => f.id === region.fertilizerOrganicId)
                organic_sum_price += Number(region.organic_input_price) * Number(region.area) * region.fertilizerCount +
                    (fertilizer ? fertilizer.price : 0) * region.fertilizerCount * Number(region.area)
            })
            const calculations = report.calculations;
            fertilizer_calculation_data.main = report.main_rows
            fertilizer_calculation_data.feed = report.feed_rows
            fertilizer_calculation_data.pre_sowing = report.pre_sowing_rows
            calculations.map((calculation) => {
                calculation_data.push({
                    name: calculation.region.name,
                    regionId: calculation.region.id,
                    element: calculation.elements
                })
                fertilizer_calculation_data.liming.push({
                        area: calculation.region.area,
                        dose: calculation.liming_dose,
                        fertilizer_dose: calculation.liming_fertilizer_dose,
                        fertilizer_id: calculation.liming_fertilizerId,
                        name: calculation.region.name,
                        id: calculation.region.id,
                        soilId: calculation.region.soilId,
                        soil: calculation.region.soil,
                        humus: calculation.region.humus,
                        pH: calculation.region.pH,
                        intro_price: calculation.liming_input_price,
                        price: calculation.liming_fertilizer_dose * calculation.region.area * (calculation.liming_fertilizer ? calculation.liming_fertilizer.price : 0)
                    }
                )
            })
        } else {
            const response_fields = await fetch('api/field', {
                headers: !this.props.token ? {} : {'Authorization': `Bearer ${this.props.token}`}
            });
            fields_all = await response_fields.json();
            fields_all.map((field) => (
                fields.push({value: field.id, label: field.name})
            ))
            fields = fields.sort((function (a, b) {
                if (a.label < b.label) {
                    return -1;
                }
                if (a.label > b.label) {
                    return 1;
                }
                return 0;
            }))
        }
        soils?.map((f) => (
            soil_list.push({value: f.id, label: f.name})
        ))
        let crop_list = [];
        crops?.map((f) => (
            crop_list.push({value: f.id, label: f.name})
        ))
        let fertilizer_organic_list = [];
        fertilizers.map((f) => {
                fertilizer_organic_list.push({value: f.id, label: f.name})
            }
        )
        crop_list = crop_list.sort((function (a, b) {
            if (a.label < b.label) {
                return -1;
            }
            if (a.label > b.label) {
                return 1;
            }
            return 0;
        }))
        soil_list = soil_list.sort((function (a, b) {
            if (a.label < b.label) {
                return -1;
            }
            if (a.label > b.label) {
                return 1;
            }
            return 0;
        }))
        fertilizer_organic_list = fertilizer_organic_list.sort((function (a, b) {
            if (a.label < b.label) {
                return -1;
            }
            if (a.label > b.label) {
                return 1;
            }
            return 0;
        }))
        selectField.soilsGroup?.map((gr) => {
            gr.soilGroupHumus.map((p) => {
                p.soilGroupPh.sort((function (a, b) {
                    if (a.ph > b.ph) {
                        return -1;
                    }
                    if (a.ph < b.ph) {
                        return 1;
                    }
                    return 0;
                }))
            })
            gr.soilGroupHumus.sort((function (a, b) {
                if (a.humus > b.humus) {
                    return -1;
                }
                if (a.humus < b.humus) {
                    return 1;
                }
                return 0;
            }))
        })
        let A = []
        let c = []
        if (mineralFertilizer?.length > 0) {
            mineralFertilizer.map((p) => {
                p.inUse = p.inStorage
                Object.assign(p, {hide: false})
                c.push(p.price)
            })
            Object.keys(mineralFertilizer[0].element).map((currentKey) => {
                let temp = []
                mineralFertilizer.map(p => {
                    temp.push(p.element[currentKey])
                })
                A.push(temp)
            })
        }
        if (this.props.report_id) {
            const use_fertilizer_array = report.use_fertilizer_list?.map((fertilizer) => fertilizer.fertilizer_Id)
            mineralFertilizer.map((fertilizer) => {
                fertilizer.inUse = use_fertilizer_array.includes(fertilizer.id)
            })
            if(report.use_fertilizer_list.length===0){
                mineralFertilizer.map((fertilizer)=> {
                    fertilizer.inUse = fertilizer.inStorage
                })
            }
        }
        this.setState({
            soilGroup: soilGroup,
            fields_name: fields,
            soils: soils,
            fields: fields_all,
            soil_list: soil_list,
            crop_list: crop_list,
            fertilizer_organic_list: fertilizer_organic_list,
            fertilizers: fertilizers,
            default_report_name: report_name,
            crops: crops,
            mineralCoef: mineralCoef,
            mineralFertilizer: mineralFertilizer,
            A: A,
            c: c
        }, () => {
            if (this.props.report_id) {
                this.setState({report_loading: true}, () => {
                    this.setState({
                        parent_report: parent_report,
                        selected_field: [report.field],
                        fieldId: report.fieldId,
                        cropId: report.cropId,
                        yield_plan: report.yield,
                        usePredecessor: report.usePredecessor,
                        organic_sum_price: organic_sum_price,
                        calculation_data: calculation_data,
                        dose: [{expand: true, element: report.sumElementArea}],
                        calculated_field: [{
                            expand: true, element: report.sumElements
                        }],
                        prev_year: report.prevCalcId,
                        report_name: report.name,
                        report_info: {
                            date_create: report.dateCreate,
                            date_change: report.dateChange,
                            need_to_recalc: report.colorState !== 0
                        },
                        yield_price: report.yield_price,
                        yield_year: report.yield_year,
                        isLimingOpen: report.isLimingOpen,
                        coefP: report.coefP,
                        liming_sum_dose: report.liming_sum_dose,
                        liming_sum_price: report.liming_sum_price,
                        is_element_active: report.is_element_active,
                        notes: report.notes,
                        other_price: report.other_price,
                    }, () => {
                        this.setState({
                            isLimingChange: !this.state.isLimingChange,
                            fertilizerCalculationsOpen: true,
                            fertilizer_calculation_data: fertilizer_calculation_data,
                        })
                    })
                })
            }
            this.setState({
                fieldChange: !this.state.fieldChange,
                fertilizerChange: !this.state.fertilizerChange,
                predecessorChange: !this.state.predecessorChange,
                calculationsChange: !this.state.calculationChange,
            })
        })

    }
}
